import AsyncSelect from "react-select/async";

function HierarchyAutoComplete({
  value,
  onChange,
  placeholder,
  api,
  parentId,
  isDisabled = false,
  name,
}) {
  const loadOptions = async (inputValue) => {
    debugger;
    try {
      if (!inputValue || inputValue.trim().length < 1) {
        return [];
      }

      let response;

      // if parentId available
      if (parentId) {
        response = await api(inputValue, parentId);
      } else {
        response = await api(inputValue);
      }

      return (
        response?.data?.map((item) => ({
          id: item.id,
          label: item.name,
        })) || []
      );
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  return (
    <AsyncSelect
      cacheOptions={false}
      defaultOptions={false}
      value={value}
      loadOptions={loadOptions}
      onChange={onChange}
      placeholder={placeholder}
      isDisabled={isDisabled}
      name={name}
      isClearable
      getOptionLabel={(e) => e.label}
      getOptionValue={(e) => e.id}
    />
  );
}

export default HierarchyAutoComplete;
